// useDashboardData.js
import { useEffect, useState } from "react";
import axios from "axios";
import sampleData from "./sampleData";
import { loadProductionReelWiseSummaryDashboard, loadProductionSummaryDashboard } from "../../../services/dashboardService";

/**
 * useDashboardData
 * - tries to fetch from /api/dashboard (example)
 * - falls back to sampleData after a short timeout or on error
 *
 * Adjust the API endpoint to match your backend.
 */
export default function useDashboardData() {
  const [data, setData] = useState(null);
  const [reelSummaryData, setReelSummaryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        // change /api/dashboard to your real endpoint
        const today = new Date().toISOString().split('T')[0];
        const res = await fetchdashboarddata(today, today);
        if (mounted && res?.data) {
          setData(res.data);
          setLoading(false);
          return;
        }
      } catch (err) {
        // swallow - we'll fallback to sample data
        console.warn("Dashboard fetch failed, using sample data.", err?.message || err);
      }

      // // fallback to sample data (simulate small delay so UI shows loader)
      // setTimeout(() => {
      //   if (!mounted) return;
      //   setData(sampleData);
      //   setLoading(false);
      // }, 300);


    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, []);



  const fetchdashboarddata = async (from, to) => {

    try {
      setLoading(true);

      const data = await loadProductionSummaryDashboard(from, to);
      setData(data[0] || []);
      const reeldata = await loadProductionReelWiseSummaryDashboard(from, to);
      setReelSummaryData(reeldata || []);
      setLoading(false);
      return data[0] || []; // 🔥 return fetched data directly

    } catch (error) {
      alert(error.message);
    }


  };

  return { data, loading, error, fetchdashboarddata,reelSummaryData };
}
